import axios from 'axios';
import get from 'lodash.get';
import { from } from 'rxjs';

export const combineShipTogetherSalesOrders = (fulfillmentPlanId, items, fulfillmentPlanIdsWithoutItems) => {
  const body = {
    fulfillmentPlanId,
    items,
    fulfillmentPlanIdsWithoutItems,
    itemAdjustmentStrategy: 'Bulk',
  };
  const request = axios.post('/fulfillmentplan/combine', body).then((response) => {
    return get(response, 'data', undefined);
  });

  const seller$ = from(request);
  return seller$;
};
